import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import deepEqual from 'fast-deep-equal';

export type SortableItem = { position: number; name?: string; title?: string; id: number };

@Component({
  selector: 'rt-list-sortable-item',
  templateUrl: './list-sortable-item.component.html',
  styleUrls: ['./list-sortable-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListSortableItemComponent {
  @Input() public title: string;
  @Input() public item: SortableItem;
  @Input('isEdited') public titleEditorOpen: boolean = false;
  @Input() public removable: boolean = true;
  @Input() public renamable: boolean = true;
  @Input() public processing: boolean = false;
  @Input()
  public set editable(value: boolean) {
    this.removable = value;
    this.renamable = value;
  }
  public get editable(): boolean {
    return this.removable || this.renamable;
  }
  @Output() public nameChange: EventEmitter<string> = new EventEmitter();
  @Output() public delete: EventEmitter<SortableItem> = new EventEmitter();
  public isDeleteLoading: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('item' in changes) {
      const item = changes.item;
      if (this.titleEditorOpen && item && !item.firstChange) {
        const { currentValue, previousValue } = item;
        if (!deepEqual(currentValue, previousValue)) {
          this.titleEditorOpen = false;
        }
      }
    }
  }

  public onDeleteItemClick(): void {
    this.isDeleteLoading = true;
    this.delete.emit(this.item);
    this.cdRef.detectChanges();
  }

  public onEditItemClick(): void {
    this.titleEditorOpen = true;
    this.cdRef.detectChanges();
  }

  public onEditName(newName: string): void {
    this.nameChange.emit(newName);
  }

  public onCancelClick(): void {
    this.titleEditorOpen = false;
    this.cdRef.detectChanges();
  }
}
